import hydrateReactClient from '@eversports/react-app-base/hydrate-react-client'

import fragmentTypes from './graphql-checkout-possible-types'

import App from './boilerplate/App'
import getLocalizationProvider from './components/LocalizationProvider'

hydrateReactClient({
  basename: '/phoenix',
  App,
  getLocalizationProvider,
  apolloOptions: { possibleTypes: fragmentTypes.possibleTypes, uri: '/api/checkout' },
}).catch((error) => console.error(error))
